<template>
  <div class="menu_header pt-3">
    <div class="container position-relative">
      <div class="name-tabs-container container pt-4">
        <h2 class="mb-4">Appointment List(s)</h2>
        <div class="custom-tabs-scroll-wrapper overflow-auto" ref="tabsWrapper">
          <ul class="nav nav-tabs custom-tabs d-flex flex-nowrap">
            <li class="nav-item" v-for="tab in tabs" :key="tab.value">
              <a
                class="nav-link"
                :class="{ active: modelValue === tab.value }"
                @click.prevent="selectTab(tab.value, $event)"
                ref="tabRefs"
              >
                <i class="fa-solid fa-calendar-check me-2"></i>{{ tab.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from 'vue';

export default {
  name: 'AppointmentTabs',
  props: {
    modelValue: { type: String, required: true },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const tabsWrapper = ref(null);
    const tabRefs = ref([]);

    const tabs = [
      { value: 'upcoming', label: 'Appointment Details' },
      { value: 'history', label: 'Booking History' },
    ];

    const selectTab = (tab, event) => {
      if (props.modelValue !== tab) {
        emit('update:modelValue', tab);
      }

      // Scroll selected tab into view
      nextTick(() => {
        const el = event.currentTarget;
        if (el && tabsWrapper.value) {
          const wrapperRect = tabsWrapper.value.getBoundingClientRect();
          const elRect = el.getBoundingClientRect();

          if (elRect.left < wrapperRect.left || elRect.right > wrapperRect.right) {
            el.scrollIntoView({ behavior: 'smooth', inline: 'center' });
          }
        }
      });
    };

    return { tabsWrapper, tabRefs, tabs, selectTab };
  },
};
</script>

<style scoped>
.custom-tabs-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.custom-tabs-scroll-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-tabs .nav-link {
  transition: all 0.2s ease;
  cursor: pointer; /* show pointer on hover */
}
.custom-tabs .nav-link.active {
  position: relative;
  z-index: 10;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
</style>
